import { DateRangePicker } from '../../components/ui/date-range-picker'
import { Field } from '../../components/ui/field'
import { Select } from '../../components/ui/select'
import {
  parsePlainDate,
  serializePlainDate,
} from '../../lib/datetime'
import type { WorkOrderFulfillmentMode } from '../../mocks/data/work-orders'

// Status is filtered by the queue tabs only (UX-20261101-20) — no second
// status dropdown here.
export type SupplyMobileWorkOrderFilterDraft = {
  fulfillmentMode: WorkOrderFulfillmentMode | ''
  dateFrom: string
  dateTo: string
  overdueOnly: boolean
}

type SupplyMobileWorkOrderFiltersProps = {
  value: SupplyMobileWorkOrderFilterDraft
  labels: {
    route: string
    allRoutes: string
    routeValues: Record<WorkOrderFulfillmentMode, string>
    dueDate: string
    overdueOnly: string
  }
  onChange: (value: SupplyMobileWorkOrderFilterDraft) => void
}

export function SupplyMobileWorkOrderFilters({
  value,
  labels,
  onChange,
}: SupplyMobileWorkOrderFiltersProps) {
  const update = <K extends keyof SupplyMobileWorkOrderFilterDraft>(
    key: K,
    nextValue: SupplyMobileWorkOrderFilterDraft[K],
  ) => onChange({ ...value, [key]: nextValue })

  return (
    <div className="divide-y divide-[var(--color-border)]">
      <div className="space-y-4 px-4 py-5">
        <Field id="supply-work-orders-mobile-route" label={labels.route}>
          <Select
            value={value.fulfillmentMode}
            onChange={(event) =>
              update(
                'fulfillmentMode',
                event.target.value as WorkOrderFulfillmentMode | '',
              )
            }
          >
            <option value="">{labels.allRoutes}</option>
            {(
              ['hub_via_nj', 'direct_dropship'] as WorkOrderFulfillmentMode[]
            ).map((route) => (
              <option key={route} value={route}>
                {labels.routeValues[route]}
              </option>
            ))}
          </Select>
        </Field>
      </div>

      <div className="space-y-4 px-4 py-5">
        <DateRangePicker
          label={labels.dueDate}
          value={{
            start: parsePlainDate(value.dateFrom),
            end: parsePlainDate(value.dateTo),
          }}
          onChange={(range) =>
            onChange({
              ...value,
              dateFrom: serializePlainDate(range.start),
              dateTo: serializePlainDate(range.end),
            })
          }
        />

        <label className="flex min-h-11 items-center gap-3 text-sm font-medium text-[var(--color-text)]">
          <input
            type="checkbox"
            checked={value.overdueOnly}
            className="h-5 w-5 rounded border-[var(--input-border)] accent-[var(--color-action)]"
            onChange={(event) => update('overdueOnly', event.target.checked)}
          />
          {labels.overdueOnly}
        </label>
      </div>
    </div>
  )
}
